/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type AccountType = "EXTERNAL" | "INACTIVE" | "SERVICE" | "STAFF" | "STUDENT" | "TEACHER";
export type AiAccessEnum = "BANNED" | "DISABLED" | "FREEMIUM" | "PREMIUM";
export type CohortType = "CANVAS" | "CLASSLINK" | "CLEVER" | "DEMO" | "EUKA" | "ONEROSTER" | "PEARSON" | "SAFARIMONTAGE" | "SCHOOLOGY" | "SCHOOLSPLP" | "SELF_PAID" | "STANDARD";
export type CountryCodeEnum = "AD" | "AE" | "AF" | "AG" | "AI" | "AL" | "AM" | "AO" | "AQ" | "AR" | "AS" | "AT" | "AU" | "AW" | "AX" | "AZ" | "BA" | "BB" | "BD" | "BE" | "BF" | "BG" | "BH" | "BI" | "BJ" | "BL" | "BM" | "BN" | "BO" | "BQ" | "BR" | "BS" | "BT" | "BV" | "BW" | "BY" | "BZ" | "CA" | "CC" | "CD" | "CF" | "CG" | "CH" | "CI" | "CK" | "CL" | "CM" | "CN" | "CO" | "CR" | "CU" | "CV" | "CW" | "CX" | "CY" | "CZ" | "DE" | "DJ" | "DK" | "DM" | "DO" | "DZ" | "EC" | "EE" | "EG" | "EH" | "ER" | "ES" | "ET" | "FI" | "FJ" | "FK" | "FM" | "FO" | "FR" | "GA" | "GB" | "GD" | "GE" | "GF" | "GG" | "GH" | "GI" | "GL" | "GM" | "GN" | "GP" | "GQ" | "GR" | "GS" | "GT" | "GU" | "GW" | "GY" | "HK" | "HM" | "HN" | "HR" | "HT" | "HU" | "ID" | "IE" | "IL" | "IM" | "IN" | "IO" | "IQ" | "IS" | "IT" | "JE" | "JM" | "JO" | "JP" | "KE" | "KG" | "KH" | "KI" | "KM" | "KN" | "KP" | "KR" | "KW" | "KY" | "KZ" | "LA" | "LB" | "LC" | "LI" | "LK" | "LR" | "LS" | "LT" | "LU" | "LV" | "LY" | "MA" | "MC" | "MD" | "ME" | "MF" | "MG" | "MH" | "MK" | "ML" | "MM" | "MN" | "MO" | "MP" | "MQ" | "MR" | "MS" | "MT" | "MU" | "MV" | "MW" | "MX" | "MY" | "MZ" | "NA" | "NC" | "NE" | "NF" | "NG" | "NI" | "NL" | "NO" | "NP" | "NR" | "NU" | "NZ" | "OM" | "PA" | "PE" | "PF" | "PG" | "PH" | "PK" | "PL" | "PM" | "PN" | "PR" | "PS" | "PT" | "PW" | "PY" | "QA" | "RE" | "RO" | "RS" | "RU" | "RW" | "SA" | "SB" | "SC" | "SD" | "SE" | "SG" | "SH" | "SI" | "SJ" | "SK" | "SL" | "SM" | "SN" | "SO" | "SR" | "SS" | "ST" | "SV" | "SX" | "SY" | "SZ" | "TC" | "TD" | "TF" | "TG" | "TH" | "TJ" | "TK" | "TL" | "TM" | "TN" | "TO" | "TR" | "TT" | "TV" | "TW" | "TZ" | "UA" | "UG" | "UM" | "US" | "UY" | "UZ" | "VA" | "VC" | "VE" | "VG" | "VI" | "VN" | "VU" | "WF" | "WS" | "YE" | "YT" | "ZA" | "ZM" | "ZW";
export type DevGetProblemEventsBackgroundRequestsPerMinuteLimit = "N100" | "N1000" | "N10000" | "N200" | "N2000" | "N300" | "N3000" | "N400" | "N4000" | "N500" | "N5000" | "N600" | "N6000" | "N700" | "N7000" | "N800" | "N8000" | "N900" | "N9000";
export type LearningFocusStatusEnum = "INVALID" | "UNSET" | "VALID";
export type TeacherOnboardingExperiment = "FEATUREWALKTHROUGH" | "NONE" | "VIDEOS";
export type TextbookType = "CORE_TEXTBOOK" | "LEGACY" | "SKILLS_BOOK";
export type ViewerProviderQueryVariables = {};
export type ViewerProviderQueryResponse = {
    readonly viewer: {
        readonly avatar: string;
        readonly cohortType: CohortType;
        readonly country: {
            readonly code: CountryCodeEnum;
        } | null;
        readonly syllabusFocus: {
            readonly id: string;
            readonly pk: number;
            readonly textbookType: TextbookType;
        };
        readonly id: string;
        readonly userType: string;
        readonly pk: number;
        readonly firstName: string;
        readonly lastName: string;
        readonly email: string;
        readonly createdAt: string;
        readonly aiAccess: AiAccessEnum;
        readonly userPreference: {
            readonly hasClosedHelpChatSidebar: boolean;
            readonly hasDismissedOpenPromptPremiumDiscountBanner: boolean;
            readonly enableSpanishSupport: boolean;
            readonly enableTTSSupport: boolean;
            readonly hasEnabledAccessibilityMode: boolean;
            readonly hasPreviewProblemEventDataInSkills: boolean;
        };
        readonly profile: {
            readonly id: string;
            readonly isHeadTeacher: boolean;
            readonly isSchoolAdmin: boolean;
            readonly canAccessAdminReport: boolean;
            readonly isEmailVerified: boolean;
            readonly __typename: "Teacher";
            readonly school: {
                readonly countrySubdivision: {
                    readonly code: string;
                } | null;
                readonly availableSyllabuses: ReadonlyArray<{
                    readonly id: string;
                    readonly textbookType: TextbookType;
                }> | null;
            };
            readonly teacherPreference: {
                readonly hasDefaultedToSkillsTab: boolean;
            } | null;
            readonly aiHintOpenPromptMonthlyLimitRemaining: number;
        } | {
            readonly id: string;
            readonly __typename: "Student";
            readonly isTeacherStudent: boolean;
            readonly studentClasses: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly id: string;
                    };
                }>;
            };
            readonly studentSchool: {
                readonly countrySubdivision: {
                    readonly code: string;
                } | null;
            } | null;
            readonly assignedTasks: ReadonlyArray<{
                readonly id: string;
            }>;
            readonly aiHintOpenPromptMonthlyLimitRemaining: number;
            readonly leaderboardClass: {
                readonly class: {
                    readonly id: string;
                };
            } | null;
            readonly someClassCanPreviewProblemEventDataInSkills: boolean;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        };
        readonly accountType: AccountType;
        readonly featureFlags: {
            readonly adminReports: boolean;
            readonly advancedReports: boolean;
            readonly allowMultipleTeachersInClass: boolean;
            readonly assignTasksToIndividuals: boolean;
            readonly assignableTasks: boolean;
            readonly bulkAssignTasks: boolean;
            readonly classicUi: boolean;
            readonly demoCheckin: boolean;
            readonly diagnostics: boolean;
            readonly engageLite: boolean;
            readonly engageTasks: boolean;
            readonly primaryTeacherNotes: boolean;
            readonly printableWorksheets: boolean;
            readonly schoolReports: boolean;
            readonly teacherReporting: boolean;
            readonly templates: boolean;
            readonly textbook: boolean;
            readonly textbookOverviews: boolean;
            readonly topicAssessment: boolean;
            readonly unlimitedClasses: boolean;
            readonly unlimitedOpenPrompt: boolean;
            readonly worksheetAnswerKeys: boolean;
            readonly worksheets: boolean;
            readonly canEditLanternQuestions: boolean;
        };
        readonly featureFlagsV2: {
            readonly canAccessNewDistrictReport: boolean;
            readonly canAccessNewDistrictReportImpact: boolean;
            readonly canAccessNewDistrictReportSchoolLevel: boolean;
            readonly canAccessNewDistrictReportTemplates: boolean;
            readonly canPreviewProblemEventDataInSkills: boolean;
            readonly catfaEnableSecondarySaveAsTemplate: boolean;
            readonly checkinsEnableDiscoveryCheckinCapGrades: boolean;
            readonly classSkillsReportCurriculumEnableGrowth: boolean;
            readonly devGetProblemEventsBackgroundRequestsPerMinuteLimit: DevGetProblemEventsBackgroundRequestsPerMinuteLimit;
            readonly devSkillsReportEnableTimeFilter: boolean;
            readonly enableAiOpenPrompt: boolean;
            readonly enableAiPremiumTrial: boolean;
            readonly enableAiSuggestQuestions: boolean;
            readonly enableTestMode: boolean;
            readonly gamificationEnableBackgroundsAndAvatars: boolean;
            readonly gamificationEnableChallengesDaily: boolean;
            readonly gamificationEnableInlineLeaderboardNotification: boolean;
            readonly gamificationEnableLeaderboardClassSelectionPrompt: boolean;
            readonly gamificationEnableLeaderboardDock: boolean;
            readonly gamificationEnableLeaderboardModalV2: boolean;
            readonly gamificationEnableLeaderboardNotification: boolean;
            readonly gamificationEnableLeaderboardTab: boolean;
            readonly gamificationEnableLiveModePromote: boolean;
            readonly gamificationEnableMonthlyExpedition: boolean;
            readonly gamificationEnablePointsCheckins: boolean;
            readonly gamificationEnableQuestionSuccessBannerV2: boolean;
            readonly gamificationEnableShop: boolean;
            readonly gamificationEnableStudentDashboardV2: boolean;
            readonly gamificationEnableTeacherStickers: boolean;
            readonly gamificationEnableTugOfWar: boolean;
            readonly gamificationEnableWeeklyPBHeader: boolean;
            readonly gamificationHighlightStreaksInWorkbookHeader: boolean;
            readonly globalSearchEnableMVP: boolean;
            readonly graphqlEnableNodeResolver: boolean;
            readonly perfUpdateIndirectMasteryAsync: boolean;
            readonly preTopicTestCheckInCanAccess: boolean;
            readonly printEnablePageBreaksAfterPTs: boolean;
            readonly prototypeEnableWorksheetChat: boolean;
            readonly reportsEnableRecommendTasks: boolean;
            readonly showMaintenanceBanner: boolean;
            readonly showWorkbookOnboarding: boolean;
            readonly skillsActivityReportEnableOutcomeFilter: boolean;
            readonly skillsActivityReportEnableSubstrandFilter: boolean;
            readonly skillsAlchemyGradeLevelA13: boolean;
            readonly skillsShowGradeLevelOverride: boolean;
            readonly studentSkillsReportsEnableProblemEventData: boolean;
            readonly supportEnableHubspotBubble: boolean;
            readonly teacherOnboardingExperiment: TeacherOnboardingExperiment;
            readonly topicTestsEnableMVP: boolean;
            readonly workbookEnableDesmosCalculators: boolean;
            readonly workbookEnableSpanishSupport: boolean;
        };
        readonly isPartnerUser: boolean;
    };
    readonly lantern: {
        readonly viewer: {
            readonly id: string;
            readonly __typename: string;
            readonly learningFocus?: {
                readonly id: string;
                readonly title: string;
                readonly strand: {
                    readonly id: string;
                };
            } | null | undefined;
            readonly learningFocusStatus?: LearningFocusStatusEnum | undefined;
            readonly selfReportedGrade?: {
                readonly id: string;
                readonly shortTitle: string;
            } | undefined;
        } | null;
    };
};
export type ViewerProviderQuery = {
    readonly response: ViewerProviderQueryResponse;
    readonly variables: ViewerProviderQueryVariables;
};



/*
query ViewerProviderQuery {
  viewer {
    avatar
    cohortType
    country {
      code
      id
    }
    syllabusFocus {
      id
      pk
      textbookType
    }
    id
    userType
    pk
    firstName
    lastName
    email
    createdAt
    aiAccess
    userPreference {
      hasClosedHelpChatSidebar
      hasDismissedOpenPromptPremiumDiscountBanner
      enableSpanishSupport
      enableTTSSupport
      hasEnabledAccessibilityMode
      hasPreviewProblemEventDataInSkills
      id
    }
    profile {
      __typename
      ... on Teacher {
        id
        isHeadTeacher
        isSchoolAdmin
        canAccessAdminReport
        isEmailVerified
        __typename
        school {
          countrySubdivision {
            code
            id
          }
          availableSyllabuses {
            id
            textbookType
          }
          id
        }
        teacherPreference {
          hasDefaultedToSkillsTab
          id
        }
        aiHintOpenPromptMonthlyLimitRemaining
      }
      ... on Student {
        id
        __typename
        isTeacherStudent
        studentClasses: classes(first: 1) {
          edges {
            node {
              id
            }
          }
        }
        studentSchool: school {
          countrySubdivision {
            code
            id
          }
          id
        }
        assignedTasks(limit: 1) {
          id
        }
        aiHintOpenPromptMonthlyLimitRemaining
        leaderboardClass {
          class {
            id
          }
        }
        someClassCanPreviewProblemEventDataInSkills
      }
      ... on Node {
        __isNode: __typename
        id
      }
    }
    accountType
    featureFlags: typedFeatureFlags {
      adminReports
      advancedReports
      allowMultipleTeachersInClass
      assignTasksToIndividuals
      assignableTasks
      bulkAssignTasks
      classicUi
      demoCheckin
      diagnostics
      engageLite
      engageTasks
      primaryTeacherNotes
      printableWorksheets
      schoolReports
      teacherReporting
      templates
      textbook
      textbookOverviews
      topicAssessment
      unlimitedClasses
      unlimitedOpenPrompt
      worksheetAnswerKeys
      worksheets
      canEditLanternQuestions
    }
    featureFlagsV2 {
      canAccessNewDistrictReport
      canAccessNewDistrictReportImpact
      canAccessNewDistrictReportSchoolLevel
      canAccessNewDistrictReportTemplates
      canPreviewProblemEventDataInSkills
      catfaEnableSecondarySaveAsTemplate
      checkinsEnableDiscoveryCheckinCapGrades
      classSkillsReportCurriculumEnableGrowth
      devGetProblemEventsBackgroundRequestsPerMinuteLimit
      devSkillsReportEnableTimeFilter
      enableAiOpenPrompt
      enableAiPremiumTrial
      enableAiSuggestQuestions
      enableTestMode
      gamificationEnableBackgroundsAndAvatars
      gamificationEnableChallengesDaily
      gamificationEnableInlineLeaderboardNotification
      gamificationEnableLeaderboardClassSelectionPrompt
      gamificationEnableLeaderboardDock
      gamificationEnableLeaderboardModalV2
      gamificationEnableLeaderboardNotification
      gamificationEnableLeaderboardTab
      gamificationEnableLiveModePromote
      gamificationEnableMonthlyExpedition
      gamificationEnablePointsCheckins
      gamificationEnableQuestionSuccessBannerV2
      gamificationEnableShop
      gamificationEnableStudentDashboardV2
      gamificationEnableTeacherStickers
      gamificationEnableTugOfWar
      gamificationEnableWeeklyPBHeader
      gamificationHighlightStreaksInWorkbookHeader
      globalSearchEnableMVP
      graphqlEnableNodeResolver
      perfUpdateIndirectMasteryAsync
      preTopicTestCheckInCanAccess
      printEnablePageBreaksAfterPTs
      prototypeEnableWorksheetChat
      reportsEnableRecommendTasks
      showMaintenanceBanner
      showWorkbookOnboarding
      skillsActivityReportEnableOutcomeFilter
      skillsActivityReportEnableSubstrandFilter
      skillsAlchemyGradeLevelA13
      skillsShowGradeLevelOverride
      studentSkillsReportsEnableProblemEventData
      supportEnableHubspotBubble
      teacherOnboardingExperiment
      topicTestsEnableMVP
      workbookEnableDesmosCalculators
      workbookEnableSpanishSupport
    }
    isPartnerUser
  }
  lantern {
    viewer {
      id
      __typename
      ... on LanternStudent {
        learningFocus {
          id
          title
          strand {
            id
          }
        }
        learningFocusStatus
        selfReportedGrade {
          id
          shortTitle
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatar",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cohortType",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pk",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "textbookType",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Syllabus",
  "kind": "LinkedField",
  "name": "syllabusFocus",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userType",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "aiAccess",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasClosedHelpChatSidebar",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasDismissedOpenPromptPremiumDiscountBanner",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enableSpanishSupport",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enableTTSSupport",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasEnabledAccessibilityMode",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasPreviewProblemEventDataInSkills",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isHeadTeacher",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSchoolAdmin",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canAccessAdminReport",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isEmailVerified",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "CountrySubdivision",
  "kind": "LinkedField",
  "name": "countrySubdivision",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "Syllabus",
  "kind": "LinkedField",
  "name": "availableSyllabuses",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasDefaultedToSkillsTab",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "aiHintOpenPromptMonthlyLimitRemaining",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isTeacherStudent",
  "storageKey": null
},
v30 = [
  (v4/*: any*/)
],
v31 = {
  "alias": "studentClasses",
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 1
    }
  ],
  "concreteType": "ClassConnection",
  "kind": "LinkedField",
  "name": "classes",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ClassEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Class",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v30/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "classes(first:1)"
},
v32 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "limit",
      "value": 1
    }
  ],
  "concreteType": "AssignedTask",
  "kind": "LinkedField",
  "name": "assignedTasks",
  "plural": true,
  "selections": (v30/*: any*/),
  "storageKey": "assignedTasks(limit:1)"
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "LeaderboardClass",
  "kind": "LinkedField",
  "name": "leaderboardClass",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Class",
      "kind": "LinkedField",
      "name": "class",
      "plural": false,
      "selections": (v30/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "someClassCanPreviewProblemEventDataInSkills",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountType",
  "storageKey": null
},
v36 = {
  "alias": "featureFlags",
  "args": null,
  "concreteType": "TypedFeatureFlag",
  "kind": "LinkedField",
  "name": "typedFeatureFlags",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "adminReports",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "advancedReports",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowMultipleTeachersInClass",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "assignTasksToIndividuals",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "assignableTasks",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bulkAssignTasks",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "classicUi",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "demoCheckin",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "diagnostics",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "engageLite",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "engageTasks",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primaryTeacherNotes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "printableWorksheets",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "schoolReports",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teacherReporting",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "templates",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "textbook",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "textbookOverviews",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "topicAssessment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unlimitedClasses",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unlimitedOpenPrompt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "worksheetAnswerKeys",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "worksheets",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canEditLanternQuestions",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "FeatureFlagsV2",
  "kind": "LinkedField",
  "name": "featureFlagsV2",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canAccessNewDistrictReport",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canAccessNewDistrictReportImpact",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canAccessNewDistrictReportSchoolLevel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canAccessNewDistrictReportTemplates",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canPreviewProblemEventDataInSkills",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "catfaEnableSecondarySaveAsTemplate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "checkinsEnableDiscoveryCheckinCapGrades",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "classSkillsReportCurriculumEnableGrowth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "devGetProblemEventsBackgroundRequestsPerMinuteLimit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "devSkillsReportEnableTimeFilter",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableAiOpenPrompt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableAiPremiumTrial",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableAiSuggestQuestions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableTestMode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gamificationEnableBackgroundsAndAvatars",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gamificationEnableChallengesDaily",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gamificationEnableInlineLeaderboardNotification",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gamificationEnableLeaderboardClassSelectionPrompt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gamificationEnableLeaderboardDock",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gamificationEnableLeaderboardModalV2",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gamificationEnableLeaderboardNotification",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gamificationEnableLeaderboardTab",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gamificationEnableLiveModePromote",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gamificationEnableMonthlyExpedition",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gamificationEnablePointsCheckins",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gamificationEnableQuestionSuccessBannerV2",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gamificationEnableShop",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gamificationEnableStudentDashboardV2",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gamificationEnableTeacherStickers",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gamificationEnableTugOfWar",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gamificationEnableWeeklyPBHeader",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gamificationHighlightStreaksInWorkbookHeader",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "globalSearchEnableMVP",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "graphqlEnableNodeResolver",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "perfUpdateIndirectMasteryAsync",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "preTopicTestCheckInCanAccess",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "printEnablePageBreaksAfterPTs",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prototypeEnableWorksheetChat",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reportsEnableRecommendTasks",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showMaintenanceBanner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showWorkbookOnboarding",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "skillsActivityReportEnableOutcomeFilter",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "skillsActivityReportEnableSubstrandFilter",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "skillsAlchemyGradeLevelA13",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "skillsShowGradeLevelOverride",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "studentSkillsReportsEnableProblemEventData",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportEnableHubspotBubble",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teacherOnboardingExperiment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "topicTestsEnableMVP",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "workbookEnableDesmosCalculators",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "workbookEnableSpanishSupport",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPartnerUser",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "Lantern",
  "kind": "LinkedField",
  "name": "lantern",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v24/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Substrand",
              "kind": "LinkedField",
              "name": "learningFocus",
              "plural": false,
              "selections": [
                (v4/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Strand",
                  "kind": "LinkedField",
                  "name": "strand",
                  "plural": false,
                  "selections": (v30/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "learningFocusStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "LanternGrade",
              "kind": "LinkedField",
              "name": "selfReportedGrade",
              "plural": false,
              "selections": [
                (v4/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "shortTitle",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "LanternStudent",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v40 = [
  (v2/*: any*/),
  (v4/*: any*/)
],
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "CountrySubdivision",
  "kind": "LinkedField",
  "name": "countrySubdivision",
  "plural": false,
  "selections": (v40/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ViewerProviderQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Country",
            "kind": "LinkedField",
            "name": "country",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          },
          (v7/*: any*/),
          (v4/*: any*/),
          (v8/*: any*/),
          (v5/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserPreference",
            "kind": "LinkedField",
            "name": "userPreference",
            "plural": false,
            "selections": [
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "School",
                    "kind": "LinkedField",
                    "name": "school",
                    "plural": false,
                    "selections": [
                      (v25/*: any*/),
                      (v26/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeacherPreference",
                    "kind": "LinkedField",
                    "name": "teacherPreference",
                    "plural": false,
                    "selections": [
                      (v27/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v28/*: any*/)
                ],
                "type": "Teacher",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/),
                  (v24/*: any*/),
                  (v29/*: any*/),
                  (v31/*: any*/),
                  {
                    "alias": "studentSchool",
                    "args": null,
                    "concreteType": "School",
                    "kind": "LinkedField",
                    "name": "school",
                    "plural": false,
                    "selections": [
                      (v25/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v32/*: any*/),
                  (v28/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/)
                ],
                "type": "Student",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          (v35/*: any*/),
          (v36/*: any*/),
          (v37/*: any*/),
          (v38/*: any*/)
        ],
        "storageKey": null
      },
      (v39/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ViewerProviderQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Country",
            "kind": "LinkedField",
            "name": "country",
            "plural": false,
            "selections": (v40/*: any*/),
            "storageKey": null
          },
          (v7/*: any*/),
          (v4/*: any*/),
          (v8/*: any*/),
          (v5/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserPreference",
            "kind": "LinkedField",
            "name": "userPreference",
            "plural": false,
            "selections": [
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
              (v24/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "School",
                    "kind": "LinkedField",
                    "name": "school",
                    "plural": false,
                    "selections": [
                      (v41/*: any*/),
                      (v26/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeacherPreference",
                    "kind": "LinkedField",
                    "name": "teacherPreference",
                    "plural": false,
                    "selections": [
                      (v27/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v28/*: any*/)
                ],
                "type": "Teacher",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/),
                  (v29/*: any*/),
                  (v31/*: any*/),
                  {
                    "alias": "studentSchool",
                    "args": null,
                    "concreteType": "School",
                    "kind": "LinkedField",
                    "name": "school",
                    "plural": false,
                    "selections": [
                      (v41/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v32/*: any*/),
                  (v28/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/)
                ],
                "type": "Student",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v30/*: any*/),
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          },
          (v35/*: any*/),
          (v36/*: any*/),
          (v37/*: any*/),
          (v38/*: any*/)
        ],
        "storageKey": null
      },
      (v39/*: any*/)
    ]
  },
  "params": {
    "cacheID": "b2a7233428f2ebda43e44f3fa6768e76",
    "id": null,
    "metadata": {},
    "name": "ViewerProviderQuery",
    "operationKind": "query",
    "text": "query ViewerProviderQuery {\n  viewer {\n    avatar\n    cohortType\n    country {\n      code\n      id\n    }\n    syllabusFocus {\n      id\n      pk\n      textbookType\n    }\n    id\n    userType\n    pk\n    firstName\n    lastName\n    email\n    createdAt\n    aiAccess\n    userPreference {\n      hasClosedHelpChatSidebar\n      hasDismissedOpenPromptPremiumDiscountBanner\n      enableSpanishSupport\n      enableTTSSupport\n      hasEnabledAccessibilityMode\n      hasPreviewProblemEventDataInSkills\n      id\n    }\n    profile {\n      __typename\n      ... on Teacher {\n        id\n        isHeadTeacher\n        isSchoolAdmin\n        canAccessAdminReport\n        isEmailVerified\n        __typename\n        school {\n          countrySubdivision {\n            code\n            id\n          }\n          availableSyllabuses {\n            id\n            textbookType\n          }\n          id\n        }\n        teacherPreference {\n          hasDefaultedToSkillsTab\n          id\n        }\n        aiHintOpenPromptMonthlyLimitRemaining\n      }\n      ... on Student {\n        id\n        __typename\n        isTeacherStudent\n        studentClasses: classes(first: 1) {\n          edges {\n            node {\n              id\n            }\n          }\n        }\n        studentSchool: school {\n          countrySubdivision {\n            code\n            id\n          }\n          id\n        }\n        assignedTasks(limit: 1) {\n          id\n        }\n        aiHintOpenPromptMonthlyLimitRemaining\n        leaderboardClass {\n          class {\n            id\n          }\n        }\n        someClassCanPreviewProblemEventDataInSkills\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    accountType\n    featureFlags: typedFeatureFlags {\n      adminReports\n      advancedReports\n      allowMultipleTeachersInClass\n      assignTasksToIndividuals\n      assignableTasks\n      bulkAssignTasks\n      classicUi\n      demoCheckin\n      diagnostics\n      engageLite\n      engageTasks\n      primaryTeacherNotes\n      printableWorksheets\n      schoolReports\n      teacherReporting\n      templates\n      textbook\n      textbookOverviews\n      topicAssessment\n      unlimitedClasses\n      unlimitedOpenPrompt\n      worksheetAnswerKeys\n      worksheets\n      canEditLanternQuestions\n    }\n    featureFlagsV2 {\n      canAccessNewDistrictReport\n      canAccessNewDistrictReportImpact\n      canAccessNewDistrictReportSchoolLevel\n      canAccessNewDistrictReportTemplates\n      canPreviewProblemEventDataInSkills\n      catfaEnableSecondarySaveAsTemplate\n      checkinsEnableDiscoveryCheckinCapGrades\n      classSkillsReportCurriculumEnableGrowth\n      devGetProblemEventsBackgroundRequestsPerMinuteLimit\n      devSkillsReportEnableTimeFilter\n      enableAiOpenPrompt\n      enableAiPremiumTrial\n      enableAiSuggestQuestions\n      enableTestMode\n      gamificationEnableBackgroundsAndAvatars\n      gamificationEnableChallengesDaily\n      gamificationEnableInlineLeaderboardNotification\n      gamificationEnableLeaderboardClassSelectionPrompt\n      gamificationEnableLeaderboardDock\n      gamificationEnableLeaderboardModalV2\n      gamificationEnableLeaderboardNotification\n      gamificationEnableLeaderboardTab\n      gamificationEnableLiveModePromote\n      gamificationEnableMonthlyExpedition\n      gamificationEnablePointsCheckins\n      gamificationEnableQuestionSuccessBannerV2\n      gamificationEnableShop\n      gamificationEnableStudentDashboardV2\n      gamificationEnableTeacherStickers\n      gamificationEnableTugOfWar\n      gamificationEnableWeeklyPBHeader\n      gamificationHighlightStreaksInWorkbookHeader\n      globalSearchEnableMVP\n      graphqlEnableNodeResolver\n      perfUpdateIndirectMasteryAsync\n      preTopicTestCheckInCanAccess\n      printEnablePageBreaksAfterPTs\n      prototypeEnableWorksheetChat\n      reportsEnableRecommendTasks\n      showMaintenanceBanner\n      showWorkbookOnboarding\n      skillsActivityReportEnableOutcomeFilter\n      skillsActivityReportEnableSubstrandFilter\n      skillsAlchemyGradeLevelA13\n      skillsShowGradeLevelOverride\n      studentSkillsReportsEnableProblemEventData\n      supportEnableHubspotBubble\n      teacherOnboardingExperiment\n      topicTestsEnableMVP\n      workbookEnableDesmosCalculators\n      workbookEnableSpanishSupport\n    }\n    isPartnerUser\n  }\n  lantern {\n    viewer {\n      id\n      __typename\n      ... on LanternStudent {\n        learningFocus {\n          id\n          title\n          strand {\n            id\n          }\n        }\n        learningFocusStatus\n        selfReportedGrade {\n          id\n          shortTitle\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'bf063f9bf6fd069b4f2c852c82d2d4bd';
export default node;
